// This component is generated by svgr. DO NOT EDIT.
import { SVGProps } from 'react'
type Props = {
  size?: 'sm' | 'md' | 'lg' | (string & {}),
} & Omit<SVGProps<SVGSVGElement>, 'width' | 'height'>
const SvgMessageWarning = ({ size = 'md', ...props }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    height={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    fill="none"
    viewBox="0 0 17 16"
    {...props}
  >
    <path
      fill={props.color ?? 'currentColor'}
      d="M8.163 1.48a.97.97 0 0 1 1.674 0l7.03 12.07a.965.965 0 0 1-.836 1.45H1.969a.965.965 0 0 1-.837-1.45z"
    />
    <path
      fill="#fff"
      d="M9 5c.6 0 1 .4 1 1v3c0 .6-.4 1-1 1s-1-.4-1-1V6c0-.5.4-1 1-1M9 13.5A1.25 1.25 0 1 0 9 11a1.25 1.25 0 0 0 0 2.5"
    />
  </svg>
)
export default SvgMessageWarning
